import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoundPipe } from './round.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [RoundPipe],
  exports: [RoundPipe]
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/Users/HeinousTugboat/Projects/survivalism/src/app/shared/shared.module.ts